import { createContext, useContext } from "react";

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = { admin: "Admin", sales: "Sales Team" };

const SALES_PATHS = ["/my-dashboard", "/leads", "/customers", "/inventory", "/product-rates", "/reports", "/settings"];

export const isAdmin = (user) => user?.role === "admin";
export const canAccessPath = (user, path) => isAdmin(user) || SALES_PATHS.includes(path);
export const homePath = (user) => (isAdmin(user) ? "/dashboard" : "/my-dashboard");
